import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FilmService } from "../../services/film.service";
import { PersonService } from "../../services/person.service";
import { ContentService } from "../../services/content.service";
import { FilmModel } from '../../models/film';
import { PersonModel } from '../../models/person';
import { ContentModel } from "../../models/content";
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from "@angular/common";
import 'rxjs/add/operator/switchMap';

@Component({
  moduleId: module.id,
  selector: 'site-videoPage',
  templateUrl: './videoPage.component.html',
  styleUrls: ['./videoPage.component.css']
})
export class VideoPage implements OnInit {
  
  content: ContentModel;
  contentID: number;
  
    constructor(private filmService:FilmService, private personService:PersonService, private contentService:ContentService, private router: Router, private route: ActivatedRoute, private location: Location)
    {
    }
  
    ngOnInit(): void{
      this.route.params.switchMap((params: Params) => {
        this.contentID = +params["id"];
        return this.getContent(this.contentID);
      }).subscribe(r =>{
        this.content = r;
        this.content.publishDate = new Date(this.content.publishDate);
  
      });
    }

    private getContent(index: number): Observable<ContentModel>
    {
      return this.contentService.getContent(index).map((v,i)=>v);
    }
  
    private formatPublishDate(): string 
    {
      let monthNames: string[] = 
      [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
      ];
      let day: number = this.content.publishDate.getDate();
      let monthIndex: number = this.content.publishDate.getMonth();
      let year: number = this.content.publishDate.getFullYear();
  
      return monthNames[monthIndex] + ' ' + day + ', ' + year;
    }
  
    private getReferences(): string
    {
      let referencesString: string = "";
  
      for(let i: number = 0; i<this.content.references.length; i++)
      {
        referencesString += "<div class=\"articleReference\">" +
        this.content.references[i] +
        "</div>" +
        "</br>";
      }
      return referencesString;
    }

    private getVideoLink(): string
    {
      let videoString: string = "";
      videoString += "<iframe width=\"100%\" height=\"100%\" frameBorder=\"0\" src=\"" 
      + this.content.contentData 
      + "\">" 
      + "</iframe>";
      
      return videoString;
    }
}



// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/videoPage/videoPage.component.ts